import { get, post, patch } from '@/helpers/httpHandler';

export default {
  namespaced: true,

  actions: {
    retrieveTags: () => get('/tags'),

    retrieveTagsTranslations: () => get('/tags/translations'),

    store: (_, data) => post('/tags', data),

    update: (_, data) => patch(`/tags/${data.id}`, data),

    //assign: (_, data) => patch(`/users/${data.id}/tags`, data),

    retrieveUserTags: (_, id) => get(`/users/${id}/tags`),

    assign: (_, { user_id, userTags }) =>
      patch(`/users/${user_id}/tags`, userTags)
  }
};
